import {GET_LS_PERMISSION, GET_PROCESS_PERMISSION, GET_USER_HANDLPER, GET_USER_INFO, GET_USER_NAME, GET_USER_PERMISSION, GET_LS_CITY, GET_LS_DEPARTMENT, GET_LS_STATUS_CV, GET_LS_STATUS_TICKET} from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  error: null,
  loading: false,
  user: null,
  userPermission: null,
  isProcess:false,
  handlingPermission:null,
  infoUser:null,
  ls_permission: null,
  ls_department: null,
};

const getUser = (state, action) => {
  return updateObject(state, {
    user:action.payload
  })
}

const getUserPermission = (state, action) => {
  return updateObject(state, {
    userPermission:action.payload
  })
}

const getProcessPermission = (state, action) => {
  return updateObject(state, {
    isProcess:action.payload
  })
}

const getHandlPermission = (state, action) => {
  return updateObject(state, {
    handlingPermission:action.payload
  })
}

const getInfoUser = (state, action) => {
  return updateObject(state, {
    infoUser:action.payload
  })
}

const getLsPermission = (state, action) => {
  return updateObject(state, {
    ls_permission:action.payload
  })
}

const getLsCity = (state, action) => {
  return updateObject(state, {
    ls_city:action.payload
  })
}

const getLsDepartment = (state, action) => {
  return updateObject(state, {
    ls_department:action.payload
  })
}

const getLsStatusCV = (state, action) => {
  return updateObject(state, {
    ls_cv_status:action.payload
  })
}

const getLsStatusTicket= (state, action) => {
  return updateObject(state, {
    ls_ticket_status:action.payload
  })
}


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_NAME:
      return getUser(state, action);
    case GET_USER_PERMISSION:
      return getUserPermission(state, action);
    case GET_PROCESS_PERMISSION:
      return getProcessPermission(state, action);
    case GET_USER_HANDLPER:
      return getHandlPermission(state, action);
    case GET_USER_INFO:
      return getInfoUser(state, action);
    case GET_LS_PERMISSION:
      return getLsPermission(state, action);
    case GET_LS_CITY:
      return getLsCity(state, action);
    case GET_LS_DEPARTMENT:
      return getLsDepartment(state, action);
    case GET_LS_STATUS_CV:
      return getLsStatusCV(state, action);
    case GET_LS_STATUS_TICKET:
      return getLsStatusTicket(state, action);
    default:
      return state;
  }
};

export default reducer;
